import React from 'react';

// Line icons for the bell, its rows, the mod queues and the toast (from the approved mockups).
const PATHS = {
	bell: (
		<>
			<path d='M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9' />
			<path d='M10.3 21a1.94 1.94 0 0 0 3.4 0' />
		</>
	),
	trophy: (
		<>
			<path d='M6 9H4.5a2.5 2.5 0 0 1 0-5H6' />
			<path d='M18 9h1.5a2.5 2.5 0 0 0 0-5H18' />
			<path d='M4 22h16' />
			<path d='M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22' />
			<path d='M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22' />
			<path d='M18 2H6v7a6 6 0 0 0 12 0V2Z' />
		</>
	),
	reply: <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />,
	mention: (
		<>
			<circle cx='12' cy='12' r='4' />
			<path d='M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8' />
		</>
	),
	invite: (
		<>
			<path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
			<circle cx='9' cy='7' r='4' />
			<path d='M19 8v6' />
			<path d='M22 11h-6' />
		</>
	),
	wall: (
		<>
			<path d='M12 20h9' />
			<path d='M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z' />
		</>
	),
	shield: <path d='M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' />,
	triangle: (
		<>
			<path d='m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3' />
			<path d='M12 9v4' />
			<path d='M12 17h.01' />
		</>
	),
	ban: (
		<>
			<circle cx='12' cy='12' r='10' />
			<path d='m4.9 4.9 14.2 14.2' />
		</>
	),
	flag: (
		<>
			<path d='M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' />
			<path d='M4 22v-7' />
		</>
	),
	bug: (
		<>
			<path d='m8 2 1.88 1.88' />
			<path d='M14.12 3.88 16 2' />
			<path d='M9 7.13v-1a3 3 0 1 1 6 0v1' />
			<path d='M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6' />
			<path d='M12 20v-9' />
			<path d='M6.53 9C4.6 8.8 3 7.1 3 5' />
			<path d='M6 13H2' />
			<path d='M3 21c0-2.1 1.7-3.9 3.8-4' />
			<path d='M20.97 5c0 2.1-1.6 3.8-3.5 4' />
			<path d='M22 13h-4' />
			<path d='M17.2 17c2.1.1 3.8 1.9 3.8 4' />
		</>
	),
	check: <path d='M20 6 9 17l-5-5' />,
	close: (
		<>
			<path d='M18 6 6 18' />
			<path d='m6 6 12 12' />
		</>
	),
};

export default function NotificationIcon({ name, size = 18 }) {
	return (
		<svg
			viewBox='0 0 24 24'
			width={size}
			height={size}
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
			aria-hidden='true'
			focusable='false'
		>
			{PATHS[name]}
		</svg>
	);
}
